module.exports = __webpack_public_path__ + "img/product_mb_vn_th_my_sg_ph.caca129.svg";